import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EnrollRequest, EnrollResponse, GetBankCodesResponse, UpdateEnrollmentRequest } from '../models/enrollment.model';

@Injectable({ providedIn: 'root' })
export class EnrollmentService {
  private readonly url = environment.identityUrl.replace(/\/$/, '');
  constructor(private readonly http: HttpClient) {}

  enroll(request: EnrollRequest): Observable<EnrollResponse> {
    return this.http.post<EnrollResponse>(this.url + '/v1/EnrollMerchantToMxpPortal', request);
  }

  updateEnrollment(request: UpdateEnrollmentRequest): Observable<void> {
    return this.http.post<void>(this.url + '/v1/UpdateEnrollment', request);
  }

  getBankCodes(): Observable<GetBankCodesResponse> {
    return this.http.get<GetBankCodesResponse>(this.url + '/api/enrollment/bank-codes');
  }
}
